<template>
  <!-- The one loader (Guy, 6 Oct 2026): a quiet spinner. On a page it stays
       invisible for the first 0.4s, so data that arrives quickly shows nothing
       at all instead of a flash. Inside a button (`immediate`) it shows at once,
       because the click needs an answer. On Test Candidates a page spinner is
       always the brand navy (tc-employer-v2.css). -->
  <div
    :class="['base-loader', color, { 'base-loader--immediate': immediate, 'base-loader--small': small }]"
    role="status"
  >
    <span class="sr-only">Loading…</span>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'text-secondary'
    },
    immediate: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.base-loader {
  position: relative;
  width: 28px;
  height: 28px;
  margin: 0 auto;
  opacity: 0;
  animation: base-loader-appear 0.25s ease 0.4s forwards;
}

.base-loader--small {
  width: 16px;
  height: 16px;
}

.base-loader--immediate {
  opacity: 1;
  animation: none;
}

.base-loader::before,
.base-loader::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2.5px solid currentColor;
}

.base-loader--small::before,
.base-loader--small::after {
  border-width: 2px;
}

.base-loader::before {
  opacity: 0.15;
}

.base-loader::after {
  border-color: currentColor transparent transparent transparent;
  animation: base-loader-spin 0.8s linear infinite;
}

@keyframes base-loader-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes base-loader-appear {
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .base-loader::after {
    animation-duration: 3s;
  }
}
</style>
